import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router";
import LoginPage from './LoginPage';
import Impressum from './Impressum';
import Fryer from './fryer/Fryer';
import FryerAdd from './fryer/Fryer-add';
import ProductPage from './product/Product';
import AddProductPage from './product/AddProductPage';
import EditProductPage from './product/EditProductPage.js';
import User from './User';
import Datenschutzerklaerung from './Datenschutzerklaerung.js';
import FryerDetail from './fryer/Fryer-detail';
import MenuAppBar from './menu/MenuAppBar';
import ReportPage from './report/ReportPage';
import AddReportPage from './report/AddReportPage';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import EditReportPage from './report/EditReportPage.js';
import Recommendation from './recommendation/Recommendation';
import Footer from './Footer.js';
import { AuthProvider } from './auth/AuthContext.js';
import CookieConsent from 'react-cookie-consent';

const theme = createTheme(
  {
    palette: {
      primary: { main: '#f6b605' },
      darkPrimary: {main: '#c8d4dc'},
      secondary: { main: '#000' }
    },
  }
);

const AppRoutes = () => {
  return (
    <>
      <MenuAppBar/>
      <CookieConsent buttonText="Ok">
        Es sind Cookies notwendig, um die Funktionalität der Plattform zu gewährleisten. Details siehe <a href="/datenschutzerklaerung" style={{color: 'white', textDecoration: 'underline'}}> Datenschutzerklärung</a>.
      </CookieConsent>
      <Routes>
        <Route>
          <Route index element={<App />} />
          <Route path='login' element={<LoginPage/>}/>
          <Route path='impressum' element={<Impressum/>}/>
          <Route path='datenschutzerklaerung' element={<Datenschutzerklaerung/>}/>
          <Route path='fryer' element={<Fryer/>}/>
          <Route path='fryer/add' element={<FryerAdd/>}/>
          <Route path='fryer/detail/:id' element={<FryerDetail/>}/>
          <Route path='product' element={<ProductPage/>}/>
          <Route path='recommendation/:id' element={<Recommendation/>}/>
          <Route path='product/add' element={<AddProductPage/>}/>
          <Route path='product/edit/:id' element={<EditProductPage/>}/>
          <Route path='user' element={<User/>}/>
          <Route path='report' element={<ReportPage/>}/>
          <Route path='report/add' element={<AddReportPage/>}/>
          <Route path='report/edit/:id' element={<EditReportPage/>}/>
        </Route>
      </Routes>
      <Footer style={{marginTop: '20px', marginBottom: '20px'}} />
    </>
  );
};

const root = document.getElementById("root");
ReactDOM.createRoot(root).render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
